module.exports = __webpack_public_path__ + "img/contact.2a05e22c.jpg";